import { render, staticRenderFns } from "./iFrameWrapper.vue?vue&type=template&id=8c8b0b1a&scoped=true&"
import script from "./iFrameWrapper.vue?vue&type=script&lang=js&"
export * from "./iFrameWrapper.vue?vue&type=script&lang=js&"
import style0 from "./iFrameWrapper.vue?vue&type=style&index=0&id=8c8b0b1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8b0b1a",
  null
  
)

export default component.exports